import React, { useState, useEffect, useRef, useContext } from "react";
import { snapPositions, snapReversePositions } from "./utils";

import snapImg from "../../Assets/thanos_snap.png";
import snapReverseImg from "../../Assets/thanos_time.png";
import snapSound from "../../Assets/thanos_snap_sound.mp3";
import snapReverseSound from "../../Assets/thanos_reverse_sound.mp3";

import Scroll from "react-scroll";
import { AppContext } from "../Context";

import "../../CSS/Thanos.css";
const Thanos = ({ onSnap, onSnapReverse }) => {
  const [snap, setSnap] = useState(true);
  const [snapping, setSnapping] = useState(false);
  const [snap$, snapReverse$] = [useRef(null), useRef(null)];
  let [spritePosition, rafId] = [0, null];

  //State to save the randomly sanpped(VANISHED) section
  const [itemSnapped, setItemSnapped] = useContext(AppContext);

  const items = [
    "MainPage",
    "Education",
    "Skills",
    "Projects",
    "WorkExperience",
    "AboutMe",
    "ContactMe",
  ];

  useEffect(() => {
    snap$.current.style.background = `url(${snapImg}) -24px -9px`;
    snapReverse$.current.style.background = `url(${snapReverseImg}) -24px -9px`;
  });

  const styleGauntlet = (styles) => {
    const gauntletEl = snap ? snap$.current : snapReverse$.current;
    Object.keys(styles).forEach((prop) => {
      gauntletEl.style[prop] = styles[prop];
    });
  };

  const animateGauntlet = () => {
    const spritePositions = snap ? snapPositions : snapReversePositions;
    if (spritePositions.length === spritePosition) {
      spritePosition = 0;
      setSnapping(false);
      cancelAnimationFrame(rafId);
      setSnap(!snap);

      return snap ? onSnap() : onSnapReverse();
    }

    const [width, height] = spritePositions[spritePosition][1];
    const [marginLeft] = spritePositions[spritePosition][2] || [0];
    const [backgroundPosition] = spritePositions[spritePosition];

    styleGauntlet({ width, height, marginLeft, backgroundPosition });

    spritePosition += 1;
    rafId = requestAnimationFrame(animateGauntlet);
  };

  const playSound = () => {
    return snap
      ? new Audio(snapSound).play()
      : new Audio(snapReverseSound).play();
  };

  const doSnap = () => {
    if (snap) {
      //randomly choose a section and save it in the state -Moon
      const rItem = items[Math.floor(Math.random() * items.length)];
      setItemSnapped(rItem);
      //scroll to the selected section -Moon
      Scroll.scroller.scrollTo(`${rItem}`, {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: -100, // Scrolls to element + 50 pi
      });
    } else {
      setItemSnapped("");
      Scroll.scroller.scrollTo(`${itemSnapped}`, {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: -100, // Scrolls to element + 50 pi
      });
    }

    if (!snapping) {
      setSnapping(true);
      playSound();
      requestAnimationFrame(animateGauntlet);
    }
    console.log(itemSnapped);
  };

  return (
    <div style={{ position: "fixed", bottom: 15, right: 15, zIndex: "1" }}>
      <div onClick={doSnap} className="thanos">
        <div ref={snap$} className={`${!snap ? "hide" : ""} gauntlet`} />
        <div ref={snapReverse$} className={`${snap ? "hide" : ""} gauntlet`} />
      </div>
      <p
        style={{
          color: "red",
          fontFamily: "Avengers",
          transform: "translateY(20px)",
        }}
      >
        {snap ? "Snap?" : "Reverse?"}
      </p>
    </div>
  );
};

Thanos.defaultProps = {
  onSnap: () => {},
  onSnapReverse: () => {},
};

export default Thanos;
